const getConfig = hostname => {
    switch(hostname) {
        case 'localhost': // Android / IOS app
        case 'app.billsmoov.com.au':
        case 'billsmoov-prod.web.app': return {
            api: 'https://rest.billsmoov.com.au',
            stripePublicKey: 'pk_live_51LicD0CCpfl042Z05aL2ozIuqn4ETzMAsWARDYovcxW5f5pDnIQbNmNOUrhbcZbn0emwYNJmJlnznE6dWYroKIid00n8xYwdgO',
            firebaseApiKey: "AIzaSyCJmjo1kxTp-HR5BQ6EluHao-7ZCQ-WhIA",
            firebaseAuthDomain: "billsmoov-prod.firebaseapp.com",
            firebaseProjectId: "billsmoov-prod",
            firebaseStorageBucket: "billsmoov-prod.appspot.com",
            firebaseMessagingSenderId: "747575478735",
            firebaseAppId: "1:747575478735:web:82a7fc494a9f121ca8fd7b",
            firebaseMeasurementId: "G-FQHFRYQWZ0"
        }
        default: return {
            api: 'https://billsmoov-development.herokuapp.com',
            stripePublicKey: 'pk_test_51LicD0CCpfl042Z0y6stDR974GLuFXauig6AIhrUg8rCjje7pxE6moAZCJ79M37A6n33ieEq9FvHh2HtxIxOq8Wc000Z259Ttm',
            firebaseApiKey: "AIzaSyBamoz0zQHbJ3jRcqQXl7VxdDQ58ZHXTXQ",
            firebaseAuthDomain: "billsmoov-dev.firebaseapp.com",
            firebaseProjectId: "billsmoov-dev",
            firebaseStorageBucket: "billsmoov-dev.appspot.com",
            firebaseMessagingSenderId: "348529404529",
            firebaseAppId: "1:348529404529:web:ab9165893c1475c80e8715",
            firebaseMeasurementId: "G-JFGT6SCDX8"
        }
    }
}

export const HOST = window.location.hostname.replace('www.', '');

export const viewDashboard = Symbol('dashboard');
export const viewProviders = Symbol('providers');
export const viewPayments = Symbol('payments');
export const viewBills = Symbol('bills');
export const viewOffers = Symbol('offers');
export const viewFuel = Symbol('fuel');
export const viewSettings = Symbol('settings');
export const viewForgotPassword = Symbol('forgot-password');

export const REST_API_URL = getConfig(HOST).api;
export const STRIPE_PUBLIC_KEY = getConfig(HOST).stripePublicKey;
export const FIREBASE_API_KEY = getConfig(HOST).firebaseApiKey;
export const FIREBASE_AUTH_DOMAIN = getConfig(HOST).firebaseAuthDomain;
export const FIREBASE_PROJECT_ID = getConfig(HOST).firebaseProjectId;
export const FIREBASE_STORAGE_BUCKET = getConfig(HOST).firebaseStorageBucket;
export const FIREBASE_MESSAGING_SENDER_ID = getConfig(HOST).firebaseMessagingSenderId;
export const FIREBASE_APP_ID = getConfig(HOST).firebaseAppId;
export const FIREBASE_MEASUREMENT_ID = getConfig(HOST).firebaseMeasurementId;
